<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.stockTake.actions.apply.title')"
    :info="$t('components.stockTake.actions.apply.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.apply'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import type { StockTake } from '~/_api/models/stockTake'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success', value: StockTake): void
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const stockTake = ref<StockTake | null>(null)

const open = (item: StockTake) => {
  stockTake.value = item

  dialog.value.open()
}

const confirm = async () => {
  const item = stockTake.value!

  try {
    const saveResponse = await $api.stockTake.save(item)

    if (saveResponse.data) {
      const applyResponse = await $api.stockTake.apply(item)

      if (applyResponse.data) {
        emit('update:loading', false)
        emit('success', applyResponse.data)

        $notification.toast({
          title: $i18n.t('general.success'),
          text: $i18n.t('components.stockTake.actions.apply.successInfo', { description: (item as any).description }),
          variant: 'success',
        })

        return true
      }
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({ open })
</script>
